import { render, staticRenderFns } from "./NationalPatentReceivingOfficeList.vue?vue&type=template&id=95c9b066&"
import script from "./NationalPatentReceivingOfficeList.vue?vue&type=script&lang=js&"
export * from "./NationalPatentReceivingOfficeList.vue?vue&type=script&lang=js&"
import style0 from "./NationalPatentReceivingOfficeList.vue?vue&type=style&index=0&id=95c9b066&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports